// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.vehicle-status-history--item.item{padding-left:16px;padding-bottom:12px;margin-top:12px}div.vehicle-status-history--item.item .status{background-color:#787f87;border-radius:1px;content:\"\";top:0;bottom:12px;left:0;position:absolute;width:6px}", ""]);
// Exports
module.exports = exports;
